import { useState, type ReactNode } from "react";
import { TooltipBubble } from "../HoverTip/HoverTip";

interface KpiCardProps {
  label: string;
  value: string;
  valueColor?: string;
  suffix?: ReactNode;
  children?: ReactNode; // e.g. a sparkline
  // Styled hover popup (see HoverTip.tsx's TooltipBubble) on the whole card
  // — e.g. "P&L за период"'s own per-bot breakdown. Hover state lives here
  // (not wrapped in HoverTip itself) so the card div stays a plain block,
  // not an extra wrapper span fighting the sidebar's own column layout.
  tooltip?: ReactNode;
}

// "P&L за период" on Overview's sidebar (same column as Открытая позиция/
// Последние сделки) — a plain full-width block, not `flex: 1 1 210px`:
// this used to sit alongside Цена BTC/Баланс in a horizontal 3-card row,
// but those two moved into AppShell's header, leaving this the only card
// left; inside the sidebar's OWN vertical flex column, a 210px flex-basis
// forced a 210px-tall box regardless of actual content height (confirmed
// live — a large dead-space gap under the number).
export function KpiCard({ label, value, valueColor, suffix, children, tooltip }: KpiCardProps) {
  const [show, setShow] = useState(false);
  return (
    <div
      onMouseEnter={() => tooltip && setShow(true)}
      onMouseLeave={() => setShow(false)}
      style={{
        position: "relative",
        padding: "var(--cardpad)",
        borderRadius: 16,
        background: "var(--surface)",
        boxShadow: "var(--shadow)",
        cursor: tooltip ? "help" : undefined,
      }}
    >
      <div style={{ font: "500 12.5px 'Golos Text',sans-serif", color: "var(--fg2)" }}>{label}</div>
      <div style={{ display: "flex", alignItems: "flex-end", gap: 9, marginTop: 6 }}>
        <span
          style={{
            font: "700 clamp(25px,2.6vw,34px) 'JetBrains Mono',monospace",
            letterSpacing: "-.02em",
            whiteSpace: "nowrap",
            color: valueColor ?? "var(--fg)",
          }}
        >
          {value}
        </span>
        {suffix}
      </div>
      {children}
      {tooltip && show && <TooltipBubble content={tooltip} />}
    </div>
  );
}
